var map = {
	"./alitas_1.jpeg": "915e",
	"./alitas_2.jpeg": "28a2",
	"./bunny_chow.jpg": "45db",
	"./choripan.jpeg": "af37",
	"./fish_bobotie.jpeg": "16b1",
	"./logo.jpeg": "d804",
	"./meat_bobotie.jpeg": "cc8f",
	"./pollo.jpeg": "3b80",
	"./pollo.jpg": "6bef",
	"./soda.jpg": "251f",
	"./south_afirkas_ 2100.ttf": "02ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa07";